module.exports = __webpack_public_path__ + "img/two_2.a3c79bce.png";